import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/home-app-changeboarding';

import { MessageComponent } from './MessageComponent';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation(),
		Component: MessageComponent,
	},
});
